import {
  GET_APPS,
  GET_APPS_SUCCESS,
  GET_APPS_ERROR,
  DELETE_APP,
  DELETE_APP_SUCCESS,
  DELETE_APP_ERROR} from "./actionTypes"

export const getApps = (pageDetails) => {
  return {
    type: GET_APPS,
    payload: pageDetails
  }
}

export const getAppsSuccess = message => {
  return {
    type: GET_APPS_SUCCESS,
    payload: message,
  }
}

export const getAppsError = message => {
  return {
    type: GET_APPS_ERROR,
    payload: message,
  }
}
//GET COUNTRY
export const deleteApp = (id) => {
  return {
    type: DELETE_APP,
    payload: {id},
  }
}
export const deleteAppSuccess = (success) => {
  return {
    type: DELETE_APP_SUCCESS,
    payload: success,
  }
}
export const deleteAppError = (error) => {
  return {
    type: DELETE_APP_ERROR,
    payload: error,
  }
}